import FileSaver from 'file-saver';
import { Numbers, metricType } from '../../../utils/typeConstants';

export const exportExcel = (data: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'scorecard_payout_criteria');
    });
};
export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};
export const payqualifiersFormat = (qualifierValue: any, metricTypeName: any) => {
    let qualifierValueReturn = qualifierValue;
    if (metricTypeName?.toLowerCase() === metricType.PERCENTAGE){
        qualifierValueReturn = `${(qualifierValue * Numbers.HUNDRED)?.toFixed(Numbers.TWO)}%`;
    }
    else if (metricTypeName?.toLowerCase() === metricType.DECIMAL) {
        qualifierValueReturn = `${qualifierValue?.toFixed(Numbers.TWO)}`;
    }
    else {
        qualifierValueReturn = `${qualifierValue}`;
    }
    return qualifierValueReturn;
};

export interface SCPayoutCriteriaDetail {
    attainment_achieved: boolean;
    corrective_actions?: number;
    eligible: string;
    employee_name: string;
    employee_number: string;
    glidepath_month?: number;
    month?: number;
    ot_hours?: number;
    pay_basis: string;
    pay_qualifiers: any[];
    pay_rule_name: string;
    payout?: number;
    payout_percentage?: number;
    payout_tenure_name: string;
    scorecard_name: string;
    scorecard_role_name: string;
    standard_work_hours?: number;
    tl_assigned: string;
    tl_oracle_id?: number;
    total_associate_days?: number;
    total_metrics_attained?: number;
    total_metrics_reported?: number;
    total_metrics_targeted?: number;
    worked_hours?: number;
    regular_hours?: number;
    year?: number;
}